
import React from 'react';

interface InpaintIconProps extends React.SVGProps<SVGSVGElement> {}

const InpaintIcon: React.FC<InpaintIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245M9.53 16.122a2.25 2.25 0 00-2.69-1.65M15 12l-3.075 3.075a3.75 3.75 0 01-5.303-5.303L15 12zm0 0l4.507 4.507a3.75 3.75 0 01-5.303 5.303L15 12zm.266-2.034a3.752 3.752 0 015.168.159M15.266 9.966a3.752 3.752 0 00-5.168-.159" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /> {/* Simple circle to suggest erasing/filling an area */}
  </svg>
);

export default InpaintIcon;
